module.exports = __webpack_public_path__ + "img/20190827144555360截图20190827115931081.4fbe183a.jpg";